/**
 * A global namespace for `click` event.
 * @type {string}
 */
const mouseclickEvent = 'click';
export default mouseclickEvent;
